// See https://github.com/facebook/create-react-app/tree/master/packages/react-app-polyfill
// for instrutions for how to control the included polyfills
import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';
import React, { StrictMode } from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter as Router } from 'react-router-dom';
import { HelmetProvider, Helmet } from 'react-helmet-async';
import { SkipNav } from '@ver-uds/uswds-react';
import { GlobalStateProvider } from './context/GlobalStateContext/GlobalStateContext';
import { EnvironmentProvider } from './context/Environment/EnvironmentContext';
import SecurityProvider from './context/Security/SecurityProvider';
import ErrorBoundary from './components/ErrorBoundary/ErrorBoundary';
import MockHandler from './mocks/MockHandler';
import NrProvider from './components/NrProvider/NrProvider';
import { TogglesProvider } from './context/Toggles/TogglesContext';

import '@ver-uds/styles';

import AppRoute from './AppRoute';

// eslint-disable-next-line react/no-deprecated
ReactDOM.render(
  <StrictMode>
    <SkipNav>
      <ErrorBoundary>
        <EnvironmentProvider>
          <TogglesProvider>
            <NrProvider>
              <MockHandler>
                <Router>
                  <SecurityProvider>
                    <GlobalStateProvider>
                      <HelmetProvider>
                        <Helmet defaultTitle="E-Verify" titleTemplate="%s | E-Verify" />
                        <AppRoute />
                      </HelmetProvider>
                    </GlobalStateProvider>
                  </SecurityProvider>
                </Router>
              </MockHandler>
            </NrProvider>
          </TogglesProvider>
        </EnvironmentProvider>
      </ErrorBoundary>
    </SkipNav>
  </StrictMode>,
  document.getElementById('root'),
);
